import React, { useEffect, useState } from 'react';
import { suscribirse } from '../config/cargando';
import './CargandoGlobal.css';

/**
 * Velo de carga de toda la aplicación.
 *
 * Lo levantan los interceptores de axios: aparece solo si la espera pasa de un
 * tercio de segundo, o de inmediato al guardar y borrar. Ver `config/cargando.ts`.
 *
 * El logo NO gira: es un cuadrado con una nota dentro y girarlo se ve torcido.
 * Late suavemente y a su alrededor da vueltas un aro. Se lee como "estoy
 * trabajando" sin maltratar la marca.
 */
const CargandoGlobal: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => suscribirse(setVisible), []);

  if (!visible) return null;

  return (
    <div className="cargando" role="status" aria-live="polite" aria-busy="true">
      <div className="cargando-caja">
        <div className="cargando-aro" aria-hidden />
        <img className="cargando-logo" src="/logo.svg" alt="" width={56} height={56} />
      </div>
      <span className="visually-hidden">Cargando…</span>
    </div>
  );
};

export default CargandoGlobal;
